import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-delivery-term',
  templateUrl: './delivery-term.component.html',
  styleUrls: ['./delivery-term.component.css']
})
export class DeliveryTermComponent implements OnInit {
    public deliveryTermNo: string;

    public edit?: Edit;

    public deliveryTermNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'deliverytermlangs', gotoParms: () => this.edit!.deliveryterm_no ?? '' }
    ];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.deliveryTermNo = this.stateService.getStateParams()['deliveryterm_no'];
    }

    private async loadEdit() {
        if (!!this.deliveryTermNo) {
            this.edit = (await this.datatask.Post(1532, { deliveryterm_no: this.deliveryTermNo }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1533, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    deliveryterm_no: string;
    deliveryterm_name: string;
    combiterms_code: string;
    include_freight_main: number;
    include_freight_last: number;
    include_customs_last: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deliveryTerm', {
//        templateUrl: 'views/components/views/deliveryTerm/deliveryTerm.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'deliveryTermService', function ($stateParams, stateService, translateService, modalService, deliveryTermService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let deliveryTermNo = $stateParams.deliveryterm_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                deliveryTermNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('deliverytermlangs', { deliveryterm_no: vm.model.edit.deliveryterm_no }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await deliveryTermService.getEdit({ deliveryterm_no: deliveryTermNo }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                deliveryTermService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
